import { StoneLocationData } from "../declarations";

export const STONE_LIST: StoneLocationData[] = [
    {
        stoneId: 0,
        locationName: 'Ansilvund',
        sublocationName: 'Ansilvund Burial Chambers',
        holdName: 'Eastmarch',
        stonePlacementDescription: 'Enter Ansilvund Excavation and complete the objective in the Ansilvund Burial Chambers, and it will be on the table in the back of the final room. Near the Ghostblade and Fjori\'s ghost.',
        stonePlacementImageFilename: 'ansilvund.jpg',
        stonePlacementImageAltText: 'Ansilvund Stone Location',
        locationImageFilename: 'ansilvund.jpg',
        locationImageAltText: 'Ansilvund Map',
    },
    {
        stoneId: 1,
        locationName: 'Stony Creek Cave',
        holdName: 'Eastmarch',
        stonePlacementDescription: 'Going off the main corridor, follow a path on the right (before entering the large pool of water with one bandit). It is inside the bandit wizard\'s cavern, on a table near an alchemy lab.',
        stonePlacementImageFilename: 'stony_creek_cave.jpg',
        stonePlacementImageAltText: 'Stony Creek Cave Stone Location',
        locationImageFilename: 'stony_creek_cave.jpg',
        locationImageAltText: 'Stony Creek Cave Map',
    },
    {
        stoneId: 2,
        locationName: 'Windhelm',
        sublocationName: 'House of Clan Shatter-Shield',
        holdName: 'Eastmarch',
        stonePlacementDescription: 'Upstairs and in the first bedroom on the left, on the bookshelf.',
        stonePlacementImageFilename: 'windhelm_house_of_clan_shatter-shield.jpg',
        stonePlacementImageAltText: 'Windhelm, House of Clan Shatter-Shield Stone Location',
        locationImageFilename: 'windhelm_house_of_clan_shatter-shield.jpg',
        locationImageAltText: 'Windhelm, House of Clan Shatter-Shield Map',
    },
    {
        stoneId: 3,
        locationName: 'Windhelm',
        sublocationName: 'Palace of the Kings',
        holdName: 'Eastmarch',
        stonePlacementDescription: 'When entering the palace, take the first door to the left (upstairs) and follow the hall to the end. It sits on a table in Wuunferth the Unliving\'s quarters at the end of the hall.',
        stonePlacementImageFilename: 'windhelm_palace_of_the_kings.jpg',
        stonePlacementImageAltText: 'Windhelm, Palace of the Kings Stone Location',
        locationImageFilename: 'windhelm_palace_of_the_kings.jpg',
        locationImageAltText: 'Windhelm, Palace of the Kings Map',
    },
    {
        stoneId: 4,
        locationName: 'Dark Brotherhood Sanctuary',
        holdName: 'Falkreath',
        stonePlacementDescription: 'On the dresser in Astrid\'s room during the quest "With Friends Like These..." or "Destroy the Dark Brotherhood!"',
        stonePlacementImageFilename: 'dark_brotherhood_sanctuary.jpg',
        stonePlacementImageAltText: 'Dark Brotherhood Sanctuary Stone Location',
        locationImageFilename: 'dark_brotherhood_sanctuary.jpg',
        locationImageAltText: 'Dark Brotherhood Sanctuary Map',
    },
    {
        stoneId: 5,
        locationName: 'Pinewatch',
        sublocationName: 'Bandit\'s Sanctuary',
        holdName: 'Falkreath',
        stonePlacementDescription: 'In a room containing a single bandit and several empty draugr sarcophagi, there is another small room (to the right, behind a locked door).\nThe stone is found on a shelf immediately on your right.',
        stonePlacementImageFilename: 'pinewatch.jpg',
        stonePlacementImageAltText: 'Pinewatch Stone Location',
        locationImageFilename: 'pinewatch.jpg',
        locationImageAltText: 'Pinewatch Map',
    },
    {
        stoneId: 6,
        locationName: 'Sunderstone Gorge',
        holdName: 'Falkreath',
        stonePlacementDescription: 'On the altar in front of the Word Wall. Note that, because of its placement on the altar, the Stone can be difficult to spot if you are not facing the Word Wall from the opposite side of the table.',
        stonePlacementImageFilename: 'sunderstone_gorge.jpg',
        stonePlacementImageAltText: 'Sunderstone Gorge Stone Location',
        locationImageFilename: 'sunderstone_gorge.jpg',
        locationImageAltText: 'Sunderstone Gorge Map',
    },
    {
        stoneId: 7,
        locationName: 'Dainty Sload',
        holdName: 'Haafingar',
        stonePlacementDescription: 'Take the stairs to the bottom level, take the stairs up (opposite the ones you have just come down). At the end of the room you will find the stone on the table.',
        stonePlacementImageFilename: 'dainty_sload.jpg',
        stonePlacementImageAltText: 'Dainty Sload Stone Location',
        locationImageFilename: 'dainty_sload.jpg',
        locationImageAltText: 'Dainty Sload Map',
    },
    {
        stoneId: 8,
        locationName: 'Reeking Cave',
        holdName: 'Haafingar',
        stonePlacementDescription: 'In the alcove with the dead conjurer near the road entrance.',
        stonePlacementImageFilename: 'reeking_cave.jpg',
        stonePlacementImageAltText: 'Reeking Cave Stone Location',
        locationImageFilename: 'reeking_cave.jpg',
        locationImageAltText: 'Reeking Cave Map',
    },
    {
        stoneId: 9,
        locationName: 'Solitude',
        sublocationName: 'Blue Palace',
        holdName: 'Haafingar',
        stonePlacementDescription: 'On the bedside table in Jarl Elisif\'s quarters. Her room is at the end of the hallway forward and to the right-hand side, facing away from the throne.',
        stonePlacementImageFilename: 'solitude_blue_palace.jpg',
        stonePlacementImageAltText: 'Solitude, Blue Palace Stone Location',
        locationImageFilename: 'solitude_blue_palace.jpg',
        locationImageAltText: 'Solitude, Blue Palace Map',
    },
    {
        stoneId: 10,
        locationName: 'Solitude',
        sublocationName: 'Proudspire Manor',
        holdName: 'Haafingar',
        stonePlacementDescription: 'Sitting on a chest of drawers on the left-hand side of the upstairs master bedroom. (Must own Proudspire Manor to get this stone. Requires paying 25,000 Gold to own.)',
        stonePlacementImageFilename: 'solitude_proudspire_manor.jpg',
        stonePlacementImageAltText: 'Solitude, Proudspire Manor Stone Location',
        locationImageFilename: 'solitude_proudspire_manor.jpg',
        locationImageAltText: 'Solitude, Proudspire Manor Map',
    },
    {
        stoneId: 11,
        locationName: 'Rannveig\'s Fast',
        holdName: 'Hjaalmarch',
        stonePlacementDescription: 'On a table just to the right of the prison\'s exit gate. The prison is entered via a trapdoor in front of the chest at the Word Wall, or long way through tunnels.',
        stonePlacementImageFilename: 'rannveigs_fast.jpg',
        stonePlacementImageAltText: 'Rannveig\'s Fast Stone Location',
        locationImageFilename: 'rannveigs_fast.jpg',
        locationImageAltText: 'Rannveig\'s Fast Map',
    },
    {
        stoneId: 12,
        locationName: 'Dead Crone Rock',
        holdName: 'The Reach',
        stonePlacementDescription: 'On a makeshift altar in front of the Word Wall at the top of the final tower.',
        stonePlacementImageFilename: 'dead_crone_rock.jpg',
        stonePlacementImageAltText: 'Dead Crone Rock Stone Location',
        locationImageFilename: 'dead_crone_rock.jpg',
        locationImageAltText: 'Dead Crone Rock Map',
    },
    {
        stoneId: 13,
        locationName: 'Markarth',
        sublocationName: 'Treasury House',
        holdName: 'The Reach',
        stonePlacementDescription: 'Next to the bed in the master bedroom.',
        stonePlacementImageFilename: 'markarth.jpg',
        stonePlacementImageAltText: 'Markarth Stone Location',
        locationImageFilename: 'markarth.jpg',
        locationImageAltText: 'Markarth Map',
    },
    {
        stoneId: 14,
        locationName: 'Understone Keep',
        sublocationName: 'Dwemer Museum',
        holdName: 'The Reach',
        stonePlacementDescription: 'Behind a locked gate on left of the museum on a table in the right hand corner.',
        stonePlacementImageFilename: 'understone_keep.jpg',
        stonePlacementImageAltText: 'Understone Keep Stone Location',
        locationImageFilename: 'understone_keep.jpg',
        locationImageAltText: 'Understone Keep Map',
    },
    {
        stoneId: 15,
        locationName: 'Black-Briar Lodge',
        holdName: 'The Rift',
        stonePlacementDescription: 'On the left end table in the upstairs master bedroom.',
        stonePlacementImageFilename: 'black-briar_lodge.jpg',
        stonePlacementImageAltText: 'Black-Briar Lodge Stone Location',
        locationImageFilename: 'black-briar_lodge.jpg',
        locationImageAltText: 'Black-Briar Lodge Map',
    },
    {
        stoneId: 16,
        locationName: 'Mistveil Keep',
        sublocationName: 'Jarl\'s Chambers',
        holdName: 'The Rift',
        stonePlacementDescription: 'In the Jarl\'s chambers, on the end table to the left of the bed in the master bedroom.',
        stonePlacementImageFilename: 'mistveil_keep.jpg',
        stonePlacementImageAltText: 'Mistveil Keep Stone Location',
        locationImageFilename: 'mistveil_keep.jpg',
        locationImageAltText: 'Mistveil Keep Map',
    },
    {
        stoneId: 17,
        locationName: 'Dragonsreach',
        sublocationName: 'Jarl\'s Quarters',
        holdName: 'Whiterun',
        stonePlacementDescription: 'In the Jarl\'s chambers, on the end table to the right of the bed.',
        stonePlacementImageFilename: 'dragonsreach.jpg',
        stonePlacementImageAltText: 'Dragonsreach Stone Location',
        locationImageFilename: 'dragonsreach.jpg',
        locationImageAltText: 'Dragonsreach Map',
    },
    {
        stoneId: 18,
        locationName: 'Fellglow Keep',
        holdName: 'Whiterun',
        stonePlacementDescription: 'On a counter in the workshop at the top of the front foyer. It is between the arcane enchanter and the alchemy lab.',
        stonePlacementImageFilename: 'fellglow_keep.jpg',
        stonePlacementImageAltText: 'Fellglow Keep Stone Location',
        locationImageFilename: 'fellglow_keep.jpg',
        locationImageAltText: 'Fellglow Keep Map',
    },
    {
        stoneId: 19,
        locationName: 'Jorrvaskr',
        sublocationName: 'Living Quarters',
        holdName: 'Whiterun',
        stonePlacementDescription: 'In Kodlak Whitemane\'s bedroom.',
        stonePlacementImageFilename: 'jorrvaskr.jpg',
        stonePlacementImageAltText: 'Jorrvaskr Stone Location',
        locationImageFilename: 'jorrvaskr.jpg',
        locationImageAltText: 'Jorrvaskr Map',
    },
    {
        stoneId: 20,
        locationName: 'Whiterun Hall of the Dead',
        sublocationName: 'Whiterun Catacombs',
        holdName: 'Whiterun',
        stonePlacementDescription: 'Found in a crypt. From the entrance make the first left, then right, down the ramp. From here it is on the immediate left.',
        stonePlacementImageFilename: 'whiterun_hall_of_the_dead.jpg',
        stonePlacementImageAltText: 'Whiterun Hall of the Dead Stone Location',
        locationImageFilename: 'whiterun_hall_of_the_dead.jpg',
        locationImageAltText: 'Whiterun Hall of the Dead Map',
    },
    {
        stoneId: 21,
        locationName: 'College of Winterhold',
        sublocationName: 'Arch-Mage\'s Quarters',
        holdName: 'Winterhold',
        stonePlacementDescription: 'On a shelf in the Arch-Mage\'s Quarters. To the left of the bed, under a wolf\'s head mounted on the wall. Becomes accessible during "Under Saarthal" when Tolfdir tells the Dragonborn to speak to the Arch-mage.',
        stonePlacementImageFilename: 'college_of_winterhold.jpg',
        stonePlacementImageAltText: 'College of Winterhold Stone Location',
        locationImageFilename: 'college_of_winterhold.jpg',
        locationImageAltText: 'College of Winterhold Map',
    },
    {
        stoneId: 22,
        locationName: 'Hob\'s Fall Cave',
        holdName: 'Winterhold',
        stonePlacementDescription: 'After crossing the bridge, just before an area with a few impaled corpses and an arcane enchanter, take the path to the left and down into an area with an alchemy bench. The stone is on a shelf.',
        stonePlacementImageFilename: 'hobs_fall_cave.jpg',
        stonePlacementImageAltText: 'Hob\'s Fall Cave Stone Location',
        locationImageFilename: 'hobs_fall_cave.jpg',
        locationImageAltText: 'Hob\'s Fall Cave Map',
    },
    {
        stoneId: 23,
        locationName: 'Yngvild',
        sublocationName: 'Yngvild Throne Room',
        holdName: 'Winterhold',
        stonePlacementDescription: 'Found on the desk in the last room, next to the final journal of Arondil.',
        stonePlacementImageFilename: 'yngvild.jpg',
        stonePlacementImageAltText: 'Yngvild Stone Location',
        locationImageFilename: 'yngvild.jpg',
        locationImageAltText: 'Yngvild Map',
    },
]